<template>
    <div class="app-container">
        <el-skeleton v-if="ejectLoading" :rows="6" animated />
        <el-form v-else :rules="rules" ref="form" :model="form" label-width="88px" style="max-width: 512px">
            <el-form-item label="图片/动图" prop="cover_url">
                <upload-one v-model="form.cover_url" width="314px" height="433px"></upload-one>
                <p class="tip">*请上传png/jpg/jpeg图片 (314*433倍数)</p>
            </el-form-item>

            <el-form-item label="跳转类型" prop="link_type">
                <el-select v-model="form.link_type" placeholder="请选择" @change="getNavigationType">
                    <el-option v-for="item in jumpTypeOptions" :key="item.val" :label="item.label" :value="item.val">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item v-if="form.link_type === 1" label="活动" prop="link_to" :rules="[{
                required: true, message: '请选择活动', trigger: 'blur'
            }]">
                <el-select v-loading="activityLoading" v-model="form.link_to" filterable>
                    <el-option v-for="(type, tIndex) in activityList" :key="tIndex" :label="type.title" :value="type.id" />
                </el-select>
            </el-form-item>

            <el-form-item v-if="form.link_type === 2" label="测评商品" prop="link_to" :rules="[{
                required: true, message: '请选择测评商品', trigger: 'blur'
            }]">
                <el-select v-loading="activityLoading" v-model="form.link_to" filterable>
                    <el-option v-for="(type, tIndex) in activityList" :key="tIndex" :label="type.name" :value="type.id" />
                </el-select>
            </el-form-item>

            <el-form-item v-if="form.link_type === 3" label="跳转链接" prop="link_to" :rules="[{
                required: true, message: '请输入跳转路径', trigger: 'blur'
            }]">
                <el-input v-model="form.link_to" />
            </el-form-item>

            <el-form-item v-if="form.link_type === 4" label="平台文章" prop="link_to" :rules="[{
                required: true, message: '请选择平台文章', trigger: 'blur'
            }]">
                <el-select v-loading="activityLoading" v-model="form.link_to" filterable>
                    <el-option v-for="(type, tIndex) in activityList" :key="tIndex" :label="type.title" :value="type.id" />
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="onSubmit" :loading="btnLoading">提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { banner, alert } from "@/api/operation"

export default {
    data: () => ({
        jumpTypeOptions: [
            {
                val: 1,
                label: "活动"
            },
            {
                val: 2,
                label: "测评商品"
            },
            {
                val: 3,
                label: "公众号文章"
            },
            {
                val: 4,
                label: "平台内文章"
            },
            {
                val: 5,
                label: "无跳转"
            }
        ],
        rules: {
            cover_url: [{ required: true, message: '请上传图片/动图', trigger: 'blur' }],
            link_type: [{ required: true, message: "请选择跳转类型", trigger: "blur" }],
            description: [{ required: false, message: "请输入描述文字", trigger: "blur" }]
        },
        form: {
            id: null,
            cover_url: null,
            link_type: null,
            link_to: '',
            description: ''
        },
        ejectLoading: false,
        activityLoading: false,
        activityList: [],
        btnLoading: false
    }),
    methods: {
        async getNavigationType(link_type) {
            this.form.link_to = ''
            if (link_type === 3 || link_type === 5) return

            this.activityLoading = true

            const { data } = await banner.navigationType(link_type)

            this.activityList = data

            this.activityLoading = false
        },
        onSubmit() {
            this.$refs["form"].validate(async (valid) => {
                if (valid) {
                    this.btnLoading = true;
                    try {
                        await alert.set(this.form)
                        this.$notify({
                            title: "成功",
                            message: "保存成功",
                            type: "success",
                            duration: 2000
                        });
                    } catch {
                        this.$message.error('出错了!');
                    } finally {
                        this.btnLoading = false;
                    }
                }
            });
        }
    },
    created() {
        this.ejectLoading = true

        alert.get().then(async ({ data }) => {
            this.form = { ...data, link_to: Number(data.link_to) }

            if (data.link_type === 3 || data.link_type === 5) return

            this.activityLoading = true

            const { data: activityList } = await banner.navigationType(data.link_type, data.link_to)

            this.activityList = activityList

            this.activityLoading = false
        }).finally(() => {
            this.ejectLoading = false
        })
    }
}
</script>

<style lang="scss" scoped>
.tip {
    font-size: .9rem;
    color: #909399;
    margin: 0;
}
</style>